<template>
  <div>
    <v-skeleton-loader v-if="profileSectionLoading" v-bind="attrs" type="card" />
    <div v-else-if="profileSection">
      <UserInfo :userInfo="profileSection.publicProfile"/>
    </div>
  </div>

</template>
<script>
import UserInfo from "@/components/User/UserInfo.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'PublicProfileInfo',
  components: {UserInfo},
  data(){
    return {
      attrs: {
        elevation: 0,
      },
    }
  },
  methods: {
    ...mapActions('app',['setPageTitle']),
    ...mapActions('auth',['getProfileSection', 'clearProfileSection']),
  },
  computed: {
    ...mapGetters('auth',['profileSection','profileSectionLoading','profileSectionError']),
  },
  mounted () {
    this.setPageTitle('Public Profile');
  },
  created () {
    this.getProfileSection('publicProfile')
  },
  beforeDestroy () {
    this.setPageTitle('');
    this.clearProfileSection();
  }
}

</script>

<style lang="scss">

</style>